export function showEventModal(trigger) {
    const wrapper = trigger.parentElement;
    if (!wrapper) return;

    const dialog = wrapper.querySelector("dialog");
    if (!dialog || typeof dialog.showModal !== "function") return;

    if (!dialog.open) {
        dialog.showModal();
    }

    const scrollContainer = dialog.querySelector("div");
    const closeBtn = dialog.querySelector("span.absolute");

    if (scrollContainer) {
        scrollContainer.scroll({ top: 0 });
    } else {
        dialog.scroll({ top: 0 });
    }

    if (closeBtn) {
        closeBtn.addEventListener(
            "click",
            () => {
                dialog.close();
            },
            { once: true }
        );
    }

    var eventModalId = dialog.id;
    var eventId = eventModalId.split("eModal-")[1];
    updateUrlParameter('eventId', eventId);
}


/**
 * Initializes Event Dialog Triggers for "event-dialog" classes
 * @param {string} scope Gets the current Document
 * @returns Initializes Event Dialog Triggers for all classes with "event-dialog"
 */
export function initEventDialogs(scope = document) {
    const triggers = scope.querySelectorAll(".event-dialog");

    triggers.forEach((trigger) => {
        if (trigger.dataset.eventDialogAvailable === "true") return;

        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            showEventModal(trigger);
        });

        trigger.dataset.eventDialogAvailable = "true";
    });
}

function showEventModalFromUrlParameter() {
    // Create a URLSearchParams instance from the current URL query string.
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve the value of the "eventId" parameter.
    const eventId = urlParams.get('eventId');

    // Check if the eventId parameter exists and is not an empty string.
    if (eventId) {
        // Prepend "eModal-" to the eventId value to form the modal element's ID.
        const modalId = `eModal-${eventId}`;

        // Find the modal element in the document by its ID.
        const modalElement = document.getElementById(modalId);

        if (modalElement) {
            modalElement.showModal();
            const closeBtn = modalElement.querySelector("span.absolute");
            modalElement.scroll({ top: 0 })
            closeBtn.addEventListener("click", () => { modalElement.close(); }, { once: true });
        } else {
            console.warn(`Modal element with id "${modalId}" not found.`);
        }
    } 
}


// Function to add or update the parameter in the current URL
export function updateUrlParameter(paramKey, paramValue) {
    // Create a URL object based on the current page URL
    const url = new URL(window.location.href);

    // Add or update the parameter
    url.searchParams.set(paramKey, paramValue);

    // Update the current URL without reloading the page
    history.pushState(null, '', url.toString());
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname === '/events') {
        showEventModalFromUrlParameter();
    }
    initEventDialogs();

});
